<template>
   <div v-if="relatedHandleType">
       <userDetailDialog  v-if="userDetailPopupShow" :userDetailPopupShow.sync="userDetailPopupShow"  :userId="related_id" />
       <SelectOrder v-if="selectOrderPopupShow" :selectOrderPopupShow.sync="selectOrderPopupShow" :selectData="relatedHandleInfo.select_data" :pk_sort="relatedHandleInfo.pk_sort" @success="successRefresh"/>
       <SelectBusiness v-if="selectBusinessPopupShow" :selectBusinessPopupShow.sync="selectBusinessPopupShow" :selectData="relatedHandleInfo.select_data" :pk_sort="relatedHandleInfo.pk_sort" @success="successRefresh"/>
       <SelectWorkOrder v-if="selectWorkOrderPopupShow" :selectWorkOrderPopupShow.sync="selectWorkOrderPopupShow" :selectData="relatedHandleInfo.select_data" :pk_sort="relatedHandleInfo.pk_sort" @success="successRefresh"/>
       <ProductCostDetail v-if="projectCostDetailPopupShow" :projectCostDetailPopupShow.sync="projectCostDetailPopupShow"  :projectId="projectId"/>
       <ChangeMembersPerson  v-if="changePersonPopupShow" :changePersonPopupShow.sync="changePersonPopupShow"  :projectId="projectId" @success="successRefresh"/>
       <MemberTpl  v-if="memberPopupShow"  :projectId="projectId"  :projectMemberId="related_id" :projectMemberInfo="relatedHandleInfo" :memberPopupShow.sync="memberPopupShow" @success="successRefresh"/>
       <AddApproval v-if="addApprovalPopupShow"  :projectId="projectId"   :addApprovalPopupShow.sync="addApprovalPopupShow" @success="successRefresh"/>
       <SelectApproval v-if="selectApprovalPopupShow"  :projectId="projectId"   :selectApprovalPopupShow.sync="selectApprovalPopupShow" @success="successRefresh"/>
       <!--  关联功能 -- 关联商机、关联订单、关联工单-->
       <RelateForm :relateFormPopupShow.sync="relateFormPopupShow" v-if="relateFormPopupShow" :relateType="relatedHandleType" :projectId="projectId" :projectDetail="projectDetail" @success="successRefresh"/>
        <!--新增订单-->
       <OrderAdd v-if="addOrderDialogVisible" :dialogVisible.sync="addOrderDialogVisible"   @refresh-list="successRefresh"/>
        <!-- 订单售后-->
       <OrderAfterSale v-if="orderAfterSaleDialog" :dialogVisible.sync="orderAfterSaleDialog"  :order_id="related_id" :orderInfo="orderAfterSaleInfo" @order_edit="handleClickEditOrder" @refresh="successRefresh"/>
       <!--订单编辑-->
       <OrderEdit v-if="editOrderDialogVisible"  :dialogVisible.sync="editOrderDialogVisible"  :order_id="related_id"  @refresh-list="successRefresh"/>
        <!-- 新增回款-->
       <RepaymentDialog v-if="repaymentDialogVisible"  :dialogVisible.sync="repaymentDialogVisible" :receivable_no.sync="related_num"  :projectId="projectId" :source="'list'" @refresh="successRefresh"/>
        <!--回款详情-->
       <RepaymentDetail v-if="repaymentDetailDialogVisible"  :dialogVisible.sync="repaymentDetailDialogVisible"  :receivable_no.sync="related_num"/>
        <!--新增开票-->
       <InvoiceAddDialog v-if="invoiceDialogVisible"  :dialogVisible.sync="invoiceDialogVisible"    :invoice_no.sync="related_num" :projectId="projectId" :source="'list'"  @refresh="successRefresh"/>
        <!--开票详情-->
       <InvoiceDetailsDialog v-if="invoiceDetailsDialogVisible"  :dialogVisible.sync="invoiceDetailsDialogVisible"  :invoice_no.sync="related_num"/>
   </div>
</template>
<script>
import {groupGetStageAndTask,getAutoSaveStagePushInfo,stagePush,projectDel,ProjectManageMemberDel,ProjectManageRelateCancel,orderHasAfterSale} from "@/api/index.js"
import {mapState} from "vuex";
import { Dialog } from "vant";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import SelectOrder from "./select_order.vue";
import SelectBusiness from "./select_business.vue";
import SelectWorkOrder from "./select_work_order.vue";
import ProductCostDetail from "./product_cost_detail.vue";
import ChangeMembersPerson from "./change_the_person"
import AddApproval from "./add_approval"
import SelectApproval from "./select_approval"
import MemberTpl from "./member_tpl"
import RelateForm from "./relate_form"
import OrderAdd from "@/views/mobile/Order/component/order_add"
import OrderEdit from "@/views/mobile/Order/component/order_edit"
import OrderAfterSale from "@/views/mobile/Order/component/order_afte_sale"
import RepaymentDialog from "@/views/mobile/Order/component/repayment_add"
import RepaymentDetail from "@/views/mobile/Order/component/repayment_detail.vue";
import InvoiceAddDialog from "@/views/mobile/Order/component/invoice_add"
import InvoiceDetailsDialog from "@/views/mobile/Order/component/invoice_detail.vue";
export default {
    name: "related_handle",
    components:{
        SelectOrder,
        SelectBusiness,
        SelectWorkOrder,
        userDetailDialog,
        ProductCostDetail,
        ChangeMembersPerson,
        MemberTpl,
        AddApproval,
        SelectApproval,
        RelateForm,
        OrderAdd,
        OrderEdit,
        OrderAfterSale,
        RepaymentDialog,
        RepaymentDetail,
        InvoiceAddDialog,
        InvoiceDetailsDialog
    },
    computed:{
        ...mapState(['tagList'])
    },
    props:{},
    data(){
        return {
            loading:false,
            projectId:null,//项目id
            projectDetail:{}, //项目详情
            relatedHandleType:'',
            relatedHandleInfo:null,
            related_id:0,
            related_num:'',
            related_ids:[],
            orderAfterSaleInfo:{},
            selectOrderPopupShow:false, //选择订单
            selectBusinessPopupShow:false, //选择商机
            selectWorkOrderPopupShow:false, //选择工单
            userDetailPopupShow:false, //用户详情
            projectCostDetailPopupShow:false,//成本明细详情
            changePersonPopupShow:false,//更换负责人
            memberPopupShow:false, //新增编辑成员
            addApprovalPopupShow:false, //新增审批
            selectApprovalPopupShow:false,//关联审批
            relateFormPopupShow:false, //关联商机-订单-工单
            addOrderDialogVisible:false,// 新增订单
            orderAfterSaleDialog:false, //订单售后
            editOrderDialogVisible:false,//订单编辑
            repaymentDialogVisible:false,//新增回款
            repaymentDetailDialogVisible:false,//回款详情
            invoiceDialogVisible:false, //新增开票
            invoiceDetailsDialogVisible:false, //开票详情
        }
    },
    created(){},
    methods: {
        handleClickRelateHandle(type,data){
            console.log(type);
            console.log(data);
            this.relatedHandleType = type
            this.relatedHandleInfo = data
            this.related_id = 0
            this.related_ids = []
            this.$nextTick(()=>{
                if(type == 'add_business'){ //新增商机

                }else if(type == 'select_business'){ //选择商机
                    this.selectBusinessPopupShow = true
                }else if(type == 'business_detail'){ //商机详情

                }else if(type =='business_disassociation'){
                    this.handleClickBusinessDisassociation() //取消关联商机
                }else if(type == 'relate_business'){
                    this.relateFormPopupShow = true// 关联商机
                }else if(type == 'add_New_quotation'){
                    // 新增报价
                }else if(type == 'add_order'){ //新增订单
                    this.addOrderDialogVisible = true
                }else if(type == 'select_order'){ //选择订单
                    this.selectOrderPopupShow = true
                }else if(type == 'order_detail'){ //订单详情
                    this.handleClickOrderDetail(this.relatedHandleInfo)
                }else if(type == 'after_sales'){
                   this.handleClickOrderAfterSales() // 订单售后
                }else if(type =='order_disassociation'){
                    this.handleClickOrderDisassociation() //取消关联订单
                }else if(type == 'relate_order'){
                    this.relateFormPopupShow = true// 关联订单
                }else if(type == 'add_work_order'){ //新增工单
                    this.handleClickAddWorkOrder()// 新建工单
                }else if(type == 'select_work_order'){ //选择工单
                    this.selectWorkOrderPopupShow = true
                }else if(type == 'work_order_detail'){ //工单详情
                    this.handleClickWorkOrderDetail()
                }else if(type =='work_order_disassociation'){
                    this.handleClickWorkOrderDisassociation() //取消关联工单
                }else if(type == 'relate_work_order'){
                    this.relateFormPopupShow = true// 关联订单
                }else if(type == 'user_detail'){ //用户详情
                    this.related_id = data.uid
                    this.userDetailPopupShow = true
                }else if(type == 'payment'){
                    this.repaymentDialogVisible = true//新建回款
                }else if(type == 'payment_detail'){
                    this.handleClickPaymentDetail() //回款详情
                }else if(type == 'invoice'){
                    this.invoiceDialogVisible = true //新增开票
                }else if(type == 'invoice_detail'){
                    this.handleClickInvoiceDetail() //开票详情
                }else if(type == 'product_cost_detail'){
                    this.projectCostDetailPopupShow = true  //产品成本详情
                }else if(type == 'order_purchase_detail'){
                     //订单代采详情
                }else if(type == 'payable_detail'){
                   //采购应付详情
                }else if(type == 'purchase'){
                    this.handleClickPurchaseDetail(this.relatedHandleInfo.id)//采购详情
                }else if(type == 'add_out_record'){
                    this.handleClickAddOutWarehouse() //新建出库
                }else if(type == 'add_in_record'){
                    this.handleClickAddInWarehouse() //新建入库
                }else if(type == 'out_record_detail'){
                    this.handleClickOutWarehouseDetail() //出库详情
                }else if(type == 'in_record_detail'){
                    this.handleClickInWarehouseDetail() //入库详情
                }else if(type == 'add_member'){
                   this.memberPopupShow = true // 添加成员
                }else if(type == 'edit_member'){
                   this.related_id = data.id
                   this.memberPopupShow = true // 编辑成员
                }else if(type == 'del_member'){
                    this.handleClickDelMember(data)// 删除成员
                }else if(type == 'change_person'){
                    this.changePersonPopupShow = true   //更换负责人
                }else if(type == 'approval_disassociation'){
                    this.handleClickApprovalDisassociation()// 取消关联审批
                }else if(type == 'add_approval'){
                    this.addApprovalPopupShow = true// 新增审批
                }else if(type == 'relate_approval'){
                    this.selectApprovalPopupShow = true// 关联审批
                }else if(type == 'approval_detail'){
                    this.handleClickApprovalDetail()
                }else if(type == 'stock_related_detail'){
                    this.handleClickStockRelatedDetail()
                }
            })
        },
        // 取消商机关联
        handleClickBusinessDisassociation(){
            Dialog.confirm({
                title: "取消关联",
                message: "确定要取消关联吗？取消后所相关的数据将同步清空",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                let postData = {
                    relate_id: this.relatedHandleInfo.project_id,
                    relate_type: 'project',
                    id:this.projectId
                }
                ProjectManageRelateCancel(postData).then(res => {
                    if(res.code == 200){
                        this.$toast('取消关联成功')
                        this.successRefresh()
                    }
                })
            })
            .catch(() => { });
        },
        // 取消关联审批
        handleClickApprovalDisassociation(){
            Dialog.confirm({
                title: "取消关联",
                message: "确定要取消关联吗？取消后所相关的数据将同步清空",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                let postData = {
                    relate_id: this.relatedHandleInfo.relate_id,
                    relate_type: 'approval',
                    id:this.projectId
                }
                ProjectManageRelateCancel(postData).then(res => {
                    if(res.code == 200){
                        this.$toast('取消关联成功')
                        this.successRefresh()
                    }
                })
            })
            .catch(() => { });

        },
        // 取消关联订单
        handleClickOrderDisassociation(){
            Dialog.confirm({
                title: "取消关联",
                message: "确定要取消关联吗？取消后所相关的数据将同步清空",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            }).then(() => {
                let postData = {
                    relate_id: this.relatedHandleInfo.order_id,
                    relate_type: 'order',
                    id:this.projectId
                }
                ProjectManageRelateCancel(postData).then(res => {
                    if(res.code == 200){
                        this.$toast('取消关联成功')
                        this.successRefresh()
                    }
                })
            }).catch(() => { });
        },
        // 取消关联工单
        handleClickWorkOrderDisassociation(){
            Dialog.confirm({
                title: "取消关联",
                message: "确定要取消关联吗？取消后所相关的数据将同步清空",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            }).then(() => {
                let postData = {
                    relate_id: this.relatedHandleInfo.id,
                    relate_type: 'workorder',
                    id:this.projectId
                }
                ProjectManageRelateCancel(postData).then(res => {
                    if(res.code == 200){
                        this.$toast('取消关联成功')
                        this.successRefresh()
                    }
                })
            }).catch(() => { });
        },
        // 删除成员
        handleClickDelMember(data){
            Dialog.confirm({
                title: "确认删除吗？",
                message: "删除后不可恢复，请谨慎操作！",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            }).then(() => {
                ProjectManageMemberDel({
                    id:data.id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast('删除成功')
                        this.successRefresh()
                    }
                }).catch(() => {

                })
            }).catch(() => { });

        },
        //点击查看回款记录详情
        handleClickPaymentDetail() {
            this.related_num = this.relatedHandleInfo.receivable_no
            this.repaymentDetailDialogVisible = true
            // this.$router.push({
            //     name: "ReceivableDetails",
            //     query: {
            //         receivable_no: this.relatedHandleInfo.receivable_no
            //     },
            // });
        },
        //点击查看开票详情
        handleClickInvoiceDetail() {
            this.related_num = this.relatedHandleInfo.invoice_no
            this.invoiceDetailsDialogVisible = true
            // this.$router.push({
            //     name: "InvoiceDetails",
            //     query: {
            //         invoice_no: this.relatedHandleInfo.invoice_no,
            //         status: this.relatedHandleInfo.status,
            //     },
            // });
        },
        // 采购详情
        handleClickPurchaseDetail(id){
            this.$router.push({
                name:'purchaseDetail',
                query:{
                    purchase_id:id
                }
            })
        },
        // 库存关联业务详情
        handleClickStockRelatedDetail(){
            if(this.relatedHandleInfo.related_info.related_type == 'purchase'){
                this.handleClickPurchaseDetail(this.relatedHandleInfo.related_info.related_id)
            }else if(this.relatedHandleInfo.related_info.related_type == 'order'){

            }
        },
        // 审批详情
        handleClickApprovalDetail() {
            this.$showApprovalDetail({
                approval_id: this.relatedHandleInfo.approval_id,
            }).then((res) => {

            });
        },
        // 订单售后
        handleClickOrderAfterSales(){
            this.related_id = this.relatedHandleInfo.order_id
            this.orderAfterSaleInfo = {
                customer_name: this.relatedHandleInfo.customer_name,
                order_num: this.relatedHandleInfo.order_num
            }
            orderHasAfterSale({
                order_id: this.relatedHandleInfo.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$toast(res.data.tips)
                    } else {
                        this.orderAfterSaleDialog = true
                    }
                }
            })
        },
        // 编辑订单
        handleClickEditOrder(){
            this.related_id = this.relatedHandleInfo.order_id
            this.editOrderDialogVisible = true
        },
        // 点击订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id ? row.order_id : undefined,
                    order_num: row.order_no ? row.order_no : undefined,
                    name: row.order_num ? row.order_num : row.order_no,
                    query_type: row.order_id ? undefined : 'order_num'
                },
            });
        },
        //新建工单
        handleClickAddWorkOrder() {
            this.$router.push({
                name: "WorkOrderAdd",
                params: {
                    isPush: true,
                },
                query: {},
            });
        },
        //工单详情
        handleClickWorkOrderDetail() {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: this.relatedHandleInfo.id,
                    name: this.relatedHandleInfo.work_order_num,
                },
            });
        },
        // 新建出库
        handleClickAddOutWarehouse(){
            let index = this.tagList.findIndex(find => find.name == 'OutWarehouseAdd')
            this.$router.push({
                name: 'OutWarehouseAdd',
                query:{
                    project_manage_id:this.projectId
                },
                params: {
                    isPush: index > -1 ? false  : true
                }
            })
        },
        // 新建入库
        handleClickAddInWarehouse(){
            let index = this.tagList.findIndex(find => find.name == 'InWarehouseAdd')
            this.$router.push({
                name: 'InWarehouseAdd',
                query:{
                    project_manage_id:this.projectId
                },
                params: {
                    isPush: index > -1 ? false  : true
                }
            })
        },
        // 出库详情
        handleClickOutWarehouseDetail(){
            this.$router.push({
                name: 'OutProductDetail',
                query:{
                   id:this.relatedHandleInfo.id
                },
                params: {
                    isPush: true
                }
            })
        },
        // 入库详情
        handleClickInWarehouseDetail(){
            this.$router.push({
                name: 'InProductDetail',
                query:{
                    id:this.relatedHandleInfo.id
                },
                params: {
                    isPush: true
                }
            })
        },















        //点击查看商机详情
        handleClickBusinessDetail({project_id, name}) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: project_id,
                    name: name,
                },
            });
        },
        //点击查看关联客户详情
        handleClickRelateCompanyDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id.value,
                    name: row.customer_id.text,
                },
            });
        },
        //新增商机事件
        handleClickAddBusiness() {
            this.addBusinessDialogVisible = true
        },
        // 编辑商机
        handleClickEditBusiness(){
            this.related_id = this.relatedHandleInfo.project_id
            this.editBusinessDialogVisible = true
        },
        // 商机推进阶段
        handleClickAdvanceNextStage() {
            let row = this.relatedHandleInfo
            groupGetStageAndTask({
                project_group_id: row.project_group_id
            }).then(res => {
                if (res.code === 200) {
                    const currentStage = res.data.find(item => item.project_stage_id === row.project_stage.value) || {}
                    if (currentStage && currentStage.sort === res.data.length) return this.$message.error('已经是最后一阶段，无法推进')
                    this.currentProjectStageId = currentStage.project_stage_id
                    this.related_id = row.project_id
                    this.nextStageId = res.data[currentStage.sort].project_stage_id
                    const field = {
                        field_form: "projects",
                        field_key: currentStage.project_stage_id,
                        field_name: currentStage.name + '任务',
                        field_type: "form_module",
                        extend: {
                            is_form_show: true
                        },
                        sort: currentStage.sort,
                        _child: currentStage.tasks
                    }
                    this.stageTaskFieldsList = [field]
                    if (this.stageTaskFieldsList.length) {
                        getAutoSaveStagePushInfo({
                            project_id: row.project_id,
                            project_stage: currentStage.project_stage_id,
                        }).then(res => {
                            if (res.code === 200) {
                                field._child.forEach(child => {
                                    if (row.hasOwnProperty(child.field_key)) {
                                        this.$set(this.stageTaskFieldsFormDetail, child.field_key, row[child.field_key])
                                    }
                                    if (res.data && res.data.hasOwnProperty(child.field_key)) {
                                        const field_value = res.data[child.field_key]
                                        if ((Array.isArray(field_value) && field_value.length) || ((typeof field_value === 'object' && !Array.isArray(field_value)) && (field_value.value !== '' && field_value.value !== undefined && field_value.value.length !== 0))) {
                                            this.$set(this.stageTaskFieldsFormDetail, child.field_key, field_value)
                                        }
                                    }
                                })
                                this.stageTaskDialogVisible = true
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {

                    }
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },
        //商机推进弹窗取消
        handleClickStageTaskDialogCancel() {
            this.stageTaskDialogVisible = false
            this.nextStageId = 0
            this.stageTaskFieldsList = []
            this.stageTaskFieldsFormDetail = {}
        },
        //商机推进弹窗确定
        handleClickStageTaskDialogConfirm() {
            this.$refs.stage_task_form.handleClickPublish()
        },

        submitTaskFormData(data) {
            stagePush({
                project_id: this.related_id,
                project_stage: this.nextStageId,
                ...data
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('推进成功')
                    this.handleClickStageTaskDialogCancel()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 商机更换负责人
        handleClickChangeThePersonBusiness(){
            this.related_ids = [this.relatedHandleInfo.project_id]
            this.changeThePersonDialogVisible = true
        },
        // 新增商机报价
        handleClickAddNewQuotation(){
            this.related_id = this.relatedHandleInfo.project_id
            this.addQuotationDialogVisible = true
        },
        // 商机添加成员
        handleClickAddMemberBusiness(){
            this.related_id = this.relatedHandleInfo.project_id
            this.addMemberDialogVisible = true
        },
        // 商机删除
        handleClickDelBusiness(){
            this.$msgbox({
                title: '确认删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger',
                iconClass: 'iconfont icon-shuoming',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger'
            }).then(() => {
                projectDel({
                    project_id: [this.relatedHandleInfo.project_id]
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                    } else {
                        this.$message.error(res.message)
                    }
                }).catch(() => {

                })
            }).catch(() => {

            })
        },

        // 查看报价单
        handleClickViewTheQuotation(){

        },
        //新建回款
        handleClickAddPayment(){
            this.repaymentDialogVisible = true
        },
        //新建开票
        handleClickAddInvoice(){
            this.invoiceDialogVisible = true
        },



        // 出库详情
        handleClickOutDetail(){
            this.related_id = this.relatedHandleInfo.id
            this.outProductDetailDialog = true
        },
        // 入库详情
        handleClickInDetail(row){
            this.related_id = this.relatedHandleInfo.id
            this.inProductDetailDialog = true
        },



        // 编辑成员
        handleClickEditMember(){
            this.related_id = this.relatedHandleInfo.id
            this.memberDialog = true
        },
        // 添加成员
        handleClickAddMember(){
            this.memberDialog = true
        },
        // 新增订单
        handleClickAddOrder(){
            this.addOrderDialogVisible = true

        },

        // 订单删除
        handleClickOrderDel(){
            this.$msgbox({
                title: '确定删除当前订单？',
                message: '停用后新建的订单或编辑停用前的订单将不展示该金额',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                iconClass: 'iconfont icon-yiwen',
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'icon_title_message_box icon_title_message_box_danger',
                confirmButtonClass: "el-button--danger",
            }).then(() => {

            }).catch(() => {
                return false
            })
        },

        // 订单代采详情
        handleClickOrderPurchaseDetail(){
            this.related_id = this.relatedHandleInfo.id
            this.orderPurchaseDetailDialog = true
        },
        // 采购应付详情
        handleClickPayableDetail(){
            this.related_num = this.relatedHandleInfo.id
            this.payableDetailsDialogVisible = true
        },
        // 操作成功回调
        successRefresh(data){
            this.$emit('relatedHandleSuccess',{type:this.relatedHandleType,data})
        },
    }
}
</script>
<style lang="scss" scoped>

</style>
